import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import LinePickingService from '../../../services/LinePickingService';
import { translate, makeEnum, isNullOrEmpty, downloadFile, showMessageToastCustom, closeCollapsible } from '../../../utils/util';
import { ENUMS } from '../../../utils/constants'
import { Breadcrumbs, Button, Input, Select, Collapsible, InfiniteScroll } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import ListItemOrder from '../LinePicking/SmallParts/Order/ListItemOrder'

const ListReportPicking = (props) => {
    const orderType = props.location?.state?.orderType;
    const [currentPage, setCurrentPage] = useState(0);
    const [arrayDrop, setArrayDrop] = useState([]);
    const [data, setData] = useState([]);
    const [orders, setOrders] = useState();
    const [filter, setFilter] = useState(
        {
            orderType: orderType,
            allOrders: true,
            dateStart: "",
            dateEnd: "",
            orderCode: "",
            orderItemCode: "",
            partNumber: "",
            routeCode: "",
            orderGroupId: "",
            cim: "",
            dolly: "",
            doca: "",
            frame: "",
            status: [],
            supplierCode: "",
            invoice: ""
        });

    useEffect(() => {
        if (orders?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(orders.items);
            } else {
                setData((prevState) => ([...prevState, ...orders.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [orders?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        var drop = makeEnum(ENUMS.eOrderStatus).map((i) => {
            return { id: i.value, text: translate(i.text, 'expedition') };
        });
        setArrayDrop(drop);
        return () => {
            setData([]);
            setOrders();
        }
        // eslint-disable-next-line
    }, []);

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport") && validateMonth()) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getOrders(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, (data) => {
                setOrders(data);
                if (click) {
                    closeCollapsible("collapsible2")
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const addStatusFilter = (item) => {
        const itemSelect = item.currentTarget.options[item.currentTarget.selectedIndex];
        if (!isNullOrEmpty(itemSelect?.value)) {
            const id = Number(itemSelect.value);
            const filterObj = {}
            Object.assign(filterObj, filter);
            if (!filter.status.find((f) => Number(f.id) === Number(id))) {
                filterObj.status.push(id);
                setFilter(filterObj);
            }
        }
    };

    const removedStatusFilter = (id) => {
        const items = filter.status.filter((item) => Number(item) !== Number(id));
        if (items) {
            const filterObj = {}
            Object.assign(filterObj, filter);
            filterObj.status = items;
            setFilter(filterObj);
        }
    }

    const validateRequired = () => {
        if (!isNullOrEmpty(filter.orderCode) || !isNullOrEmpty(filter.orderItemCode) || !isNullOrEmpty(filter.orderGroupId)) {
            return false;
        }
        return true;
    }

    const validateMonth = () => {
        var data1 = new Date(filter.dateStart);
        var data2 = new Date(filter.dateEnd);
        var total = (data2.getFullYear() - data1.getFullYear()) * 12 + (data2.getMonth() - data1.getMonth());
        if (total > 12) {
            showMessageToastCustom(translate('warning', 'general'), "Permitido apenas período de 12 Meses", 8000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }
        return true;
    }

    const downloadReport = () => {
        props.getReport(filter, (data) => {
            downloadFile(data, `ReportChamadas${Date.now()}.csv`, "data:text/csv", false);
        });
    }

    return (
        <div>
            <Breadcrumbs id="transmissionTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: 'Relatório' }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            defaultValue={filter.dateStart}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="dateStart"
                                            name="dateStart"
                                            onChange={onChange}
                                            required={validateRequired()}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.dateEnd}
                                            type="date"
                                            label={translate('change-location:endDate')}
                                            id="dateEnd"
                                            name="dateEnd"
                                            onChange={onChange}
                                            required={validateRequired()}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="orderCode"
                                            name='orderCode'
                                            label={translate('line-picking:transmission.call')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="orderItemCode"
                                            name='orderItemCode'
                                            label={translate('line-picking:linepicking.task')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="cim"
                                            name='cim'
                                            label={translate('line-picking:linepicking.CIM')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    {props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value &&
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="routeCode"
                                                name='routeCode'
                                                label={translate('line-picking:linepicking.route')}
                                                type="text"
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    <div className={`input-field no-padding col s${(props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value ? "6" : "5")}`} >
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('line-picking:linepicking.partnumber')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    {props.location?.state?.orderType === ENUMS.eOrderType.Picking.value &&
                                        <div>
                                            <div className="input-field no-padding col s6">
                                                <Input
                                                    id="supplierCode"
                                                    name='supplierCode'
                                                    label={translate('expedition:picking.supplier')}
                                                    type="text"
                                                    onChange={onChange}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s5">
                                                <Input
                                                    id="invoice"
                                                    name='invoice'
                                                    label={translate('expedition:picking.invoice')}
                                                    type="text"
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value &&
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="orderGroupId"
                                                name='orderGroupId'
                                                label={translate('line-picking:linepicking.group')}
                                                type="number"
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    {props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value &&
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="dolly"
                                                name='dolly'
                                                label="Dolly"
                                                type="text"
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    {props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value &&
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="doca"
                                                name='doca'
                                                label="Doca"
                                                type="text"
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    {props.location?.state?.orderType !== ENUMS.eOrderType.Picking.value &&
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="frame"
                                                name='frame'
                                                label="Frame"
                                                type="text"
                                                onChange={onChange}
                                            />
                                        </div>
                                    }
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="location"
                                            name='location'
                                            label={translate('line-picking:linepicking.location')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            id="status"
                                            name="status"
                                            display="description"
                                            defaultValue={""}
                                            change={addStatusFilter}
                                            label={`Status - ${translate('general:choose-one-option')}`}
                                            data={arrayDrop}
                                        />
                                    </div>
                                    {
                                        filter.status.map((item) =>
                                            <div key={item} className="no-padding col s12">
                                                <div key={`${item}-div`} className="list sixth-text-color">
                                                    <i onClick={() => removedStatusFilter(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                    {arrayDrop.find((f) => f.id === item).text}
                                                </div>
                                            </div>)
                                    }
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </>
                        }
                    />
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text="Gerar Relatorio" />
                        </div>
                    }
                </div>
                <div id="listtransmissions">
                    <InfiniteScroll
                        page={orders?.totalPages}
                        hasMore={currentPage < orders?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item) => {
                                return (
                                    <ListItemOrder
                                        report
                                        key={`o-${item.orderId}-${item.status}`}
                                        data={item}
                                    />
                                );
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrders: (filter, pagination, callback) => {
            dispatch(LinePickingService.getOrdersReport(filter, pagination, callback));
        },
        getReport: (filter, callback) => {
            dispatch(LinePickingService.getReport(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListReportPicking)));
